<template>
  <router-view/>
</template>

<script type="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class AdminEmployeeTypeMain extends Vue {}
</script>
